import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMutationState } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router';
import { AppointmentCard } from 'components/AppointmentCard';
import { MUTATION_KEYS, QueryStatus } from 'constants/common';
import { ROUTES } from 'constants/routes';
import { useFetchNextAppointments } from 'hooks/useFetchNextAppointments';

export const PsychologistAppointment = (): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.PSYCHOLOGIST);
  const { state } = useLocation();
  const params = useParams();
  const from = state?.from;
  const patientId = params?.id;
  const appointmentId = params?.appointmentId;
  const appointment = state?.appointment;
  const { isLoading: isLoadingAppointments, isFetching } = useFetchNextAppointments(
    patientId ?? '',
    appointment?.psychologistId
  );
  const isLoading = isLoadingAppointments || isFetching;
  const status = useMutationState({
    filters: { mutationKey: [MUTATION_KEYS.CANCEL_APPOINTMENT, appointmentId] },
    select: mutation => mutation.state.status,
  });

  if (!patientId || !appointmentId) return <Navigate to={ROUTES.PSYCHOLOGIST_PATIENTS} />;
  if (isLoading) return <LoadingScreen />;
  if (status.some(status => status === QueryStatus.SUCCESS)) {
    return <Navigate to={from} />;
  }

  return (
    <div className="flex flex-col gap-8">
      <h1 className="text-3xl font-semibold max-am-lg:hidden">
        {t('PsychologistAppointment.heading')}
      </h1>
      <Button variant="terciary" className="w-fit" onClick={() => navigate(from)}>
        {t('Common.back', { ns: LOCIZE_NS.COMMON })}
      </Button>
      <AppointmentCard patientId={patientId} appointment={appointment} />
    </div>
  );
};
